import React, {
    useEffect,
    useState
} from "react";

import {
    useNavigate,
    useParams
} from "react-router-dom";

import Cookies from "js-cookie";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import {
    userMe,
    getPrimePaperList
} from "../config/userApi";

import "./PremiumMCQ.css";


function PrimePapers() {

    const navigate = useNavigate();

    const {
        category
    } = useParams();


    /*
    |--------------------------------------------------------------------------
    | Decode Category
    |--------------------------------------------------------------------------
    */

    const decodedCategory = (() => {

        try {

            return decodeURIComponent(
                category || ""
            );

        } catch (error) {

            console.error(
                "Category Decode Error:",
                error
            );

            return category || "";
        }

    })();


    /*
    |--------------------------------------------------------------------------
    | State
    |--------------------------------------------------------------------------
    */

    const [
        sidebarOpen,
        setSidebarOpen
    ] = useState(false);


    const [
        name,
        setName
    ] = useState(
        Cookies.get("username") ||
        "Student"
    );


    const [
        papers,
        setPapers
    ] = useState([]);


    const [
        loading,
        setLoading
    ] = useState(true);


    const [
        error,
        setError
    ] = useState("");


    /*
    |--------------------------------------------------------------------------
    | Load Premium Papers
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        let mounted = true;


        const loadPapers = async () => {

            try {

                setLoading(true);

                setError("");


                /*
                |--------------------------------------------------------------------------
                | Category Check
                |--------------------------------------------------------------------------
                */

                if (!decodedCategory) {

                    throw new Error(
                        "Paper category is missing."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Check Logged In User
                |--------------------------------------------------------------------------
                */

                const meResponse =
                    await userMe();


                console.log(
                    "USER ME STATUS:",
                    meResponse.status
                );


                /*
                |--------------------------------------------------------------------------
                | Unauthorized
                |--------------------------------------------------------------------------
                */

                if (
                    meResponse.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );


                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );


                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | Read User Response
                |--------------------------------------------------------------------------
                */

                const meResult =
                    await meResponse.json();


                console.log(
                    "USER ME RESPONSE:",
                    meResult
                );


                if (
                    !meResponse.ok
                ) {

                    throw new Error(
                        meResult?.message ||
                        "Unable to verify user."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Set User Name
                |--------------------------------------------------------------------------
                */

                if (
                    meResult?.user
                ) {

                    const username =
                        meResult.user.fullname ||
                        meResult.user.name ||
                        meResult.user.username ||
                        "Student";


                    if (mounted) {

                        setName(
                            username
                        );

                    }


                    Cookies.set(
                        "username",
                        username
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Get Premium Paper List
                |--------------------------------------------------------------------------
                */

                console.log(
                    "GETTING PAPERS FOR CATEGORY:",
                    decodedCategory
                );


                const response =
                    await getPrimePaperList(
                        decodedCategory
                    );


                console.log(
                    "PREMIUM PAPER STATUS:",
                    response.status
                );


                /*
                |--------------------------------------------------------------------------
                | Unauthorized
                |--------------------------------------------------------------------------
                */

                if (
                    response.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );


                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );


                    return;
                }


                /*
                |--------------------------------------------------------------------------
                | Read API Response
                |--------------------------------------------------------------------------
                */

                const result =
                    await response.json();


                console.log(
                    "PREMIUM PAPER RESPONSE:",
                    result
                );


                if (
                    !response.ok
                ) {

                    throw new Error(
                        result?.message ||
                        "Unable to fetch premium papers."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | API Success Check
                |--------------------------------------------------------------------------
                */

                if (
                    result?.success === false ||
                    result?.status === false
                ) {

                    throw new Error(
                        result?.message ||
                        "Unable to fetch premium papers."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Papers
                |--------------------------------------------------------------------------
                */

                const paperData =
                    Array.isArray(
                        result?.data
                    )
                        ? result.data
                        : [];


                console.log(
                    "PAPER DATA:",
                    paperData
                );


                if (mounted) {

                    setPapers(
                        paperData
                    );

                }


            } catch (err) {

                console.error(
                    "PREMIUM PAPER ERROR:",
                    err
                );


                if (mounted) {

                    setError(
                        err?.message ||
                        "Unable to connect with server."
                    );


                    setPapers([]);

                }


            } finally {

                if (mounted) {

                    setLoading(false);

                }

            }

        };


        loadPapers();


        return () => {

            mounted = false;

        };

    }, [
        navigate,
        decodedCategory
    ]);


    /*
    |--------------------------------------------------------------------------
    | Go Back To Categories
    |--------------------------------------------------------------------------
    */

    const goBack = () => {

        navigate(
            "/prime-paper-category"
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Get Attempt Count
    |--------------------------------------------------------------------------
    */

    const getAttemptCount = (
        paper
    ) => {

        if (
            !paper
        ) {

            return 0;

        }


        /*
        |--------------------------------------------------------------------------
        | Backend attempt_count
        |--------------------------------------------------------------------------
        */

        if (
            paper.attempt_count !== undefined &&
            paper.attempt_count !== null &&
            paper.attempt_count !== ""
        ) {

            const count =
                Number(
                    paper.attempt_count
                );


            if (
                Number.isFinite(count)
            ) {

                return Math.min(
                    Math.max(
                        count,
                        0
                    ),
                    2
                );

            }

        }


        /*
        |--------------------------------------------------------------------------
        | Fallback
        |--------------------------------------------------------------------------
        */

        if (
            paper.attempted === true ||
            Number(
                paper.attempted
            ) === 1
        ) {

            return 1;

        }


        return 0;

    };


    /*
    |--------------------------------------------------------------------------
    | Get Attempt Status
    |--------------------------------------------------------------------------
    */

    const getAttemptStatus = (
        paper
    ) => {

        const attemptCount =
            getAttemptCount(
                paper
            );


        if (
            attemptCount === 0
        ) {

            return {

                type:
                    "not-attempted",

                text:
                    "Not Attempted"

            };

        }


        if (
            attemptCount === 1
        ) {

            return {

                type:
                    "attempted-once",

                text:
                    "Attempted Once"

            };

        }


        return {

            type:
                "attempted-twice",

            text:
                "You have attempted"

        };

    };


    /*
    |--------------------------------------------------------------------------
    | Get Action Text
    |--------------------------------------------------------------------------
    */

    const getActionText = (
        paper
    ) => {

        const attemptCount =
            getAttemptCount(
                paper
            );


        if (
            attemptCount === 0
        ) {

            return "Start Paper";

        }


        if (
            attemptCount === 1
        ) {

            return "Reattempt Paper";

        }


        return "Attempt Limit Reached";

    };


    /*
    |--------------------------------------------------------------------------
    | GET FIRST ATTEMPT HISTORY ID
    |--------------------------------------------------------------------------
    |
    | first_attempt_history_id MUST BE:
    |
    | user_history.id
    |
    | WHERE:
    |
    | reattempt = 0
    |
    */

    const getFirstAttemptResultId = (
        paper
    ) => {

        if (
            !paper
        ) {

            return null;

        }


        const firstAttemptId =
            paper.first_attempt_history_id;


        /*
        |--------------------------------------------------------------------------
        | Validate ID
        |--------------------------------------------------------------------------
        */

        if (
            firstAttemptId === undefined ||
            firstAttemptId === null ||
            firstAttemptId === ""
        ) {

            return null;

        }


        /*
        |--------------------------------------------------------------------------
        | Convert To String
        |--------------------------------------------------------------------------
        */

        return String(
            firstAttemptId
        );

    };


    /*
    |--------------------------------------------------------------------------
    | VIEW FIRST ATTEMPT RESULT
    |--------------------------------------------------------------------------
    |
    | Navigate to ReviewPrime.
    |
    | Send:
    |
    | 1. First Attempt History ID
    | 2. Category Name
    | 3. Paper Object
    |
    */

    const viewResult = (
        paper
    ) => {

        /*
        |--------------------------------------------------------------------------
        | First Attempt ID
        |--------------------------------------------------------------------------
        */

        const firstAttemptId =
            getFirstAttemptResultId(
                paper
            );


        /*
        |--------------------------------------------------------------------------
        | Category
        |--------------------------------------------------------------------------
        */

        const resultCategory =
            paper?.category ||
            decodedCategory;


        /*
        |--------------------------------------------------------------------------
        | Validate First Attempt ID
        |--------------------------------------------------------------------------
        */

        if (
            !firstAttemptId
        ) {

            setError(
                "First attempt result ID is not available."
            );


            console.error(
                "first_attempt_history_id is missing.",
                paper
            );


            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Validate Category
        |--------------------------------------------------------------------------
        */

        if (
            !resultCategory
        ) {

            setError(
                "Paper category is missing."
            );


            console.error(
                "Result category is missing.",
                paper
            );


            return;

        }


        /*
        |--------------------------------------------------------------------------
        | ReviewPrime URL
        |--------------------------------------------------------------------------
        |
        | Example:
        |
        | /premium-paper/review/AIAPGET26X26/51090
        |
        */

        const reviewUrl =
            `/premium-paper/review/${encodeURIComponent(
                resultCategory
            )}/${encodeURIComponent(
                firstAttemptId
            )}`;


        /*
        |--------------------------------------------------------------------------
        | Debug
        |--------------------------------------------------------------------------
        */

        console.log(
            "REVIEW URL:",
            reviewUrl
        );


        console.log(
            "FIRST ATTEMPT ID:",
            firstAttemptId
        );


        console.log(
            "REVIEW CATEGORY:",
            resultCategory
        );


        /*
        |--------------------------------------------------------------------------
        | Navigate To ReviewPrime
        |--------------------------------------------------------------------------
        */

        navigate(
            reviewUrl,
            {
                state: {

                    firstAttemptId:
                        firstAttemptId,

                    category:
                        resultCategory,

                    paper:
                        paper

                }
            }
        );

    };


    /*
    |--------------------------------------------------------------------------
    | OPEN / START / REATTEMPT PAPER
    |--------------------------------------------------------------------------
    */

    const openPaper = (
        paper
    ) => {

        console.log(
            "OPEN PREMIUM PAPER:",
            paper
        );


        /*
        |--------------------------------------------------------------------------
        | Paper ID Check
        |--------------------------------------------------------------------------
        */

        if (
            !paper ||
            paper.paper_id === undefined ||
            paper.paper_id === null ||
            paper.paper_id === ""
        ) {

            setError(
                "Paper ID is missing."
            );

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Attempt Count
        |--------------------------------------------------------------------------
        */

        const attemptCount =
            getAttemptCount(
                paper
            );


        /*
        |--------------------------------------------------------------------------
        | Allow Start / Reattempt
        |--------------------------------------------------------------------------
        */

        if (
            attemptCount < 2
        ) {

            navigate(
                `/premium-paper/start/${encodeURIComponent(
                    paper.paper_id
                )}`
            );


            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Maximum Attempts
        |--------------------------------------------------------------------------
        */

        console.log(
            "MAXIMUM ATTEMPTS REACHED:",
            paper.paper_id
        );

    };


    /*
    |--------------------------------------------------------------------------
    | LOADING
    |--------------------------------------------------------------------------
    */

    if (
        loading
    ) {

        return (

            <div className="user-dashboard">


                {/* =========================================================
                    SIDEBAR
                ========================================================= */}

                <UserSidebar

                    sidebarOpen={
                        sidebarOpen
                    }

                    setSidebarOpen={
                        setSidebarOpen
                    }

                />


                {/* =========================================================
                    MAIN
                ========================================================= */}

                <main className="dashboard-main">


                    {/* =====================================================
                        HEADER
                    ===================================================== */}

                    <UserHeader

                        name={
                            name
                        }

                        setSidebarOpen={
                            setSidebarOpen
                        }

                    />


                    {/* =====================================================
                        LOADING
                    ===================================================== */}

                    <div className="premium-mcq-loading">

                        <div
                            className="spinner-border text-primary"
                            role="status"
                        >

                            <span className="visually-hidden">

                                Loading...

                            </span>

                        </div>


                        <p className="mt-3">

                            Loading{" "}

                            {decodedCategory}

                            {" "}Papers...

                        </p>

                    </div>


                </main>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | MAIN UI
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard premium-mcq-page">


            {/* =========================================================
                SIDEBAR
            ========================================================= */}

            <UserSidebar

                sidebarOpen={
                    sidebarOpen
                }

                setSidebarOpen={
                    setSidebarOpen
                }

            />


            {/* =========================================================
                MAIN
            ========================================================= */}

            <main className="dashboard-main">


                {/* =====================================================
                    HEADER
                ===================================================== */}

                <UserHeader

                    name={
                        name
                    }

                    setSidebarOpen={
                        setSidebarOpen
                    }

                />


                {/* =====================================================
                    CONTENT
                ===================================================== */}

                <div className="dashboard-content">


                    {/* =====================================================
                        PAGE HEADER
                    ===================================================== */}

                    <section className="premium-mcq-header">


                        <div className="premium-header-content">


                            {/* BADGE */}

                            <span className="premium-mcq-badge">

                                <i className="bi bi-gem"></i>

                                PREMIUM PAPERS

                            </span>


                            {/* CATEGORY */}

                            <h1>

                                {decodedCategory}

                            </h1>


                            <p>

                                Select a paper to start your
                                premium paper practice.

                            </p>


                        </div>


                        <div className="premium-header-icon">

                            <i className="bi bi-journal-medical"></i>

                        </div>


                    </section>


                    {/* =====================================================
                        ERROR
                    ===================================================== */}

                    {error && (

                        <div className="alert alert-danger mt-4">

                            <i className="bi bi-exclamation-triangle-fill me-2"></i>

                            {error}


                            <button
                                type="button"
                                className="btn-close float-end"
                                onClick={() =>
                                    setError("")
                                }
                            ></button>

                        </div>

                    )}


                    {/* =====================================================
                        NO PAPERS
                    ===================================================== */}

                    {!error &&
                        papers.length === 0 && (

                            <div className="premium-lock-card">


                                <div className="premium-lock-icon">

                                    <i className="bi bi-journal-x"></i>

                                </div>


                                <h3>

                                    No Papers Available

                                </h3>


                                <p>

                                    No premium papers are
                                    currently available for{" "}

                                    <strong>

                                        {decodedCategory}

                                    </strong>.

                                </p>


                                <button

                                    type="button"

                                    className="premium-purchase-btn"

                                    onClick={
                                        goBack
                                    }

                                >

                                    <i className="bi bi-arrow-left"></i>

                                    Back to Categories

                                </button>


                            </div>

                        )
                    }


                    {/* =====================================================
                        PAPERS
                    ===================================================== */}

                    {!error &&
                        papers.length > 0 && (

                            <section className="premium-subjects-wrapper">


                                {/* =================================================
                                    SECTION HEADER
                                ================================================= */}

                                <div className="premium-section-header mb-4">


                                    <div className="subject-title-wrapper">


                                        <div className="subject-icon">

                                            <i className="bi bi-journal-medical"></i>

                                        </div>


                                        <div>

                                            <h2>

                                                {decodedCategory}

                                                {" "}

                                                Papers

                                            </h2>


                                            <p>

                                                {papers.length}

                                                {" "}

                                                {
                                                    papers.length === 1
                                                        ? "Paper"
                                                        : "Papers"
                                                }

                                                {" "}

                                                Available

                                            </p>

                                        </div>

                                    </div>


                                    <span className="premium-pro-badge">

                                        <i className="bi bi-gem"></i>

                                        PRO

                                    </span>


                                </div>


                                {/* =================================================
                                    PAPER CARDS
                                ================================================= */}

                                <div className="row g-4">


                                    {papers.map(

                                        (
                                            paper,
                                            index
                                        ) => {


                                            const attemptCount =
                                                getAttemptCount(
                                                    paper
                                                );


                                            const attemptStatus =
                                                getAttemptStatus(
                                                    paper
                                                );


                                            const isMaxAttempt =
                                                attemptCount >= 2;


                                            /*
                                            |--------------------------------------------------------------------------
                                            | FIRST ATTEMPT RESULT ID
                                            |--------------------------------------------------------------------------
                                            */

                                            const firstAttemptResultId =
                                                getFirstAttemptResultId(
                                                    paper
                                                );


                                            return (

                                                <div

                                                    className="col-xl-4 col-lg-6 col-md-6"

                                                    key={
                                                        paper.paper_id ||
                                                        `paper-${index}`
                                                    }

                                                >


                                                    <div className="premium-paper-card">


                                                        {/* =================================================
                                                            CARD TOP
                                                        ================================================= */}

                                                        <div className="paper-card-top">


                                                            <div className="premium-paper-number">

                                                                {String(
                                                                    index + 1
                                                                ).padStart(
                                                                    2,
                                                                    "0"
                                                                )}

                                                            </div>


                                                            <span className="premium-card-badge">

                                                                <i className="bi bi-gem"></i>

                                                                PRO

                                                            </span>


                                                        </div>


                                                        {/* =================================================
                                                            PAPER ICON
                                                        ================================================= */}

                                                        <div className="premium-paper-icon">

                                                            <i className="bi bi-journal-medical"></i>

                                                        </div>


                                                        {/* =================================================
                                                            PAPER TITLE
                                                        ================================================= */}

                                                        <h3>

                                                            {
                                                                paper.paper ||
                                                                "Premium Paper"
                                                            }

                                                        </h3>


                                                        {/* =================================================
                                                            QUESTION COUNT
                                                        ================================================= */}

                                                        <div className="premium-question-info">


                                                            <div className="question-icon">

                                                                <i className="bi bi-question-circle-fill"></i>

                                                            </div>


                                                            <div>

                                                                <strong>

                                                                    {
                                                                        paper.total_questions ||
                                                                        0
                                                                    }

                                                                </strong>


                                                                <span>

                                                                    Questions

                                                                </span>

                                                            </div>

                                                        </div>


                                                        {/* =================================================
                                                            EXAM DATE
                                                        ================================================= */}

                                                        <div className="not-attempted-box">

                                                            <i className="bi bi-calendar-event"></i>


                                                            <span>

                                                                Exam Date:{" "}


                                                                {
                                                                    paper.exam_date

                                                                        ? new Date(
                                                                            paper.exam_date
                                                                        ).toLocaleDateString(
                                                                            "en-IN",
                                                                            {
                                                                                day: "2-digit",
                                                                                month: "short",
                                                                                year: "numeric"
                                                                            }
                                                                        )

                                                                        : "Available"
                                                                }

                                                            </span>

                                                        </div>


                                                        {/* =================================================
                                                            ATTEMPT STATUS
                                                        ================================================= */}

                                                        {attemptCount === 0 && (

                                                            <div className="not-attempted-box">

                                                                <i className="bi bi-play-circle"></i>


                                                                <span>

                                                                    {
                                                                        attemptStatus.text
                                                                    }

                                                                </span>

                                                            </div>

                                                        )}


                                                        {attemptCount === 1 && (

                                                            <div className="attempted-box">


                                                                <div className="attempt-status">

                                                                    <i className="bi bi-check-circle-fill"></i>


                                                                    <span>

                                                                        {
                                                                            attemptStatus.text
                                                                        }

                                                                    </span>

                                                                </div>


                                                                <div className="score-wrapper">

                                                                    <small>

                                                                        Score

                                                                    </small>


                                                                    <strong>

                                                                        {
                                                                            paper.first_attempt_score ??
                                                                            paper.score ??
                                                                            0
                                                                        }

                                                                    </strong>

                                                                </div>

                                                            </div>

                                                        )}


                                                        {attemptCount >= 2 && (

                                                            <div className="attempted-box">


                                                                <div className="attempt-status">

                                                                    <i className="bi bi-check-circle-fill"></i>


                                                                    <span>

                                                                        {
                                                                            attemptStatus.text
                                                                        }

                                                                    </span>

                                                                </div>


                                                                <div className="score-wrapper">

                                                                    <small>

                                                                        Attempts

                                                                    </small>


                                                                    <strong>

                                                                        2/2

                                                                    </strong>

                                                                </div>

                                                            </div>

                                                        )}


                                                        {/* =================================================
                                                            START / REATTEMPT BUTTON
                                                        ================================================= */}

                                                        <button

                                                            type="button"

                                                            className={
                                                                `premium-action-btn ${
                                                                    isMaxAttempt
                                                                        ? "disabled"
                                                                        : ""
                                                                }`
                                                            }

                                                            onClick={() =>
                                                                openPaper(
                                                                    paper
                                                                )
                                                            }

                                                            disabled={
                                                                isMaxAttempt
                                                            }

                                                        >

                                                            <span>

                                                                {
                                                                    getActionText(
                                                                        paper
                                                                    )
                                                                }

                                                            </span>


                                                            <i

                                                                className={

                                                                    attemptCount === 0

                                                                        ? "bi bi-arrow-right"

                                                                        : attemptCount === 1

                                                                            ? "bi bi-arrow-repeat"

                                                                            : "bi bi-lock-fill"

                                                                }

                                                            ></i>

                                                        </button>


                                                        {/* =================================================
                                                            VIEW RESULT BUTTON
                                                        ================================================= */}

                                                        {attemptCount >= 1 && (

                                                            <button

                                                                type="button"

                                                                className="premium-action-btn mt-2"

                                                                onClick={() =>
                                                                    viewResult(
                                                                        paper
                                                                    )
                                                                }

                                                                disabled={
                                                                    !firstAttemptResultId
                                                                }

                                                                title={

                                                                    firstAttemptResultId

                                                                        ? "View First Attempt Result"

                                                                        : "First attempt result is not available"

                                                                }

                                                            >

                                                                <span>

                                                                    View Result

                                                                </span>


                                                                <i className="bi bi-eye"></i>

                                                            </button>

                                                        )}


                                                       
                                                    </div>

                                                </div>

                                            );

                                        }

                                    )}

                                </div>


                            </section>

                        )
                    }


                </div>


            </main>


        </div>

    );

}


export default PrimePapers;